import { ReportsScreen } from './ReportsScreen.jsx';

export default {
  path: '/reports',
  element: <ReportsScreen />,
  protected: true,
  permission: 'reports.view',
  standalone: false,
  sidebar: { label: 'التقارير', icon: 'reports', group: 'admin', order: 91 }
};
